// Variable to define all route names and their values
// Make sure to define these in ascending tabValue order -- 0 is always first, then 1, etc.
export const routes = {
  biochem: [
    { tabName: "pending", tabValue: 0 },
    { tabName: "hmc", tabValue: 1 },
  ],
  pcr: [
    { tabName: "starletpcr", tabValue: 0 },
    { tabName: "manualpcr", tabValue: 1 },
  ],
};

// Method to handle updating the path
// setValue is the method to update state, history is the history object from useHistory()
export const updatePath = (currentPath, value, pageName, setValue, history) => {
  const tabs = routes[pageName];
  const name = `/${pageName}`;

  if (value !== undefined) {
    tabs.forEach((item) => {
      if (value === item.tabValue) {
        history.push(`${name}/${item.tabName}`);
      }
    });
  } else if (currentPath === name) {
    history.push(`${name}/${tabs[0].tabName}`);
  } else {
    tabs.forEach((item) => {
      if (currentPath === (`${name}/${item.tabName}`)) {
        setValue(item.tabValue);
      }
    });
  }
};

export const updatePathWithTabs = (currentPath, value, pageName, setValue, tabs, history) => {
  const name = `/${pageName}`;

  if (value !== undefined) {
    tabs.forEach((item) => {
      if (value === item.tabValue) {
        history.push(`${name}/${item.route}`);
      }
    });
  } else if (currentPath === name && tabs.length > 0) {
    history.push(`${name}/${tabs[0].route}`);
  } else {
    tabs.forEach((item) => {
      if (currentPath === (`${name}/${item.route}`)) {
        setValue(item.tabValue);
      }
    });
  }
};
